<div class="page page-departments">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <ul class="page-breadcrumb">
          <li><a> Página inicial </a></li>
          <li><a> Documentos e Pastas </a></li>
          <li><a> Departamentos </a></li>
        </ul>
      </div>
      <div class="col-12"><h2>Departamentos</h2></div>
      <div class="col-12">
        <div class="departments-list">
          <div class="row">
            <div class="col-12 mt-3">
              <div class="department-nav">
                <div class="buttons">
                  <button
                    type="button"
                    class="btn btn-sm btn-secondary"
                    (click)="open(modalCreateDepartment)"
                  >
                    Criar novo departamento
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mt-5">
              <div class="department-list">
                <app-folder-list
                  [collection]="collection"
                  (activity)="doAction($event)"
                >
                </app-folder-list>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modalCreateDepartment let-modal>
  <app-modal-action
    [modal]="modal"
    [typeModal]="'simple green'"
    [showHeader]="true"
    [showFooter]="false"
    [showClose]="false"
    [title]="'Adicionar departamento'"
  >
    <app-department-form
      [modal]="modal"
      [selected]="selectedDepartment"
      [isLoading]="isLoading"
    ></app-department-form>
  </app-modal-action>
</ng-template>
